import { createRouter } from '@/core/router/createRouter';
import { CROSS_SELLING_ROUTES } from './CrossSelling.routes';

export default createRouter(CROSS_SELLING_ROUTES);
